import { createFileRoute, Link } from "@tanstack/react-router";
import { ArrowRight } from "lucide-react";
import { TraumaResponseWheel } from "@/components/feelings/TraumaResponseWheel";

const TITLE = "Trauma Response Wheel — Recovery Trauma™";
const DESCRIPTION =
  "Explore how your nervous system may be responding — fight, flight, freeze, fawn or shutdown. Self-reflection, not a diagnosis.";

export const Route = createFileRoute("/trauma-response-wheel")({
  validateSearch: (s: Record<string, unknown>) => ({
    response: typeof s.response === "string" ? s.response : undefined,
  }),
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESCRIPTION },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: DESCRIPTION },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
    links: [{ rel: "canonical", href: "https://recoverytrauma.com/trauma-response-wheel" }],
  }),
  component: TraumaResponseWheelPage,
});

function TraumaResponseWheelPage() {
  const { response } = Route.useSearch();
  return (
    <main className="mx-auto w-full max-w-5xl px-4 pt-4 pb-10 sm:px-6 sm:pt-8">
      <TraumaResponseWheel initialKey={response ?? null} />
      <div className="mx-auto mt-6 max-w-xl">
        <Link
          to="/how-are-you-feeling"
          className="inline-flex items-center gap-1.5 text-sm font-medium text-[var(--gold-deep)] hover:underline"
        >
          Not sure what you're feeling? Open the Emotion Wheel <ArrowRight className="h-4 w-4" aria-hidden />
        </Link>
      </div>
    </main>
  );
}
